import NotFoundPage from '@shared/components/common/NotFoundPage';
import { ROUTES } from '@shared/configs/constants';

export default function UserNotFoundPage() {
    return (
        <div className='h-screen'>
            <NotFoundPage homeHref={ROUTES.home.href} />
        </div>
    );
}
